"use strict";
import * as React from "react";
import htmlToReact from "html-react-parser";

const PortfolioImage = ({ prevImage, nextImage, currentImage, imageMax }) => (
  <React.Fragment>
    <button type="button" className="close" data-dismiss="modal">
      &times;
    </button>
    <div className="portfolio-navigation">
      <div
        onClick={() => prevImage()}
        className={currentImage.imageindex === 0 ? "back disabled" : "back"}
      />
      <div
        onClick={() => nextImage()}
        className={
          imageMax === currentImage.imageindex ? "next disabled" : "next"
        }
      />
    </div>
    <div
      className="image-area"
      style={{
        backgroundImage: `url(img/${currentImage.imageid}/${
          currentImage.imgName
        })`
      }}
    />

    <div className="description-area">
      <div className="modal-header" />
      <p className="portfolio-title">{htmlToReact(currentImage.name)}</p>
      <div className="portfolio-description">
        {currentImage.description ? htmlToReact(currentImage.description) : ""}
      </div>
    </div>
  </React.Fragment>
);

export default PortfolioImage;



// WEBPACK FOOTER //
// ./src/components/PortfolioImage.js